// @ts-nocheck
import * as Types from "../../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type UpdateOrganizationSamlCertificateMutationVariables = Types.Exact<{
  organizationSlug: Types.Scalars["ID"]["input"];
  idpCert: Types.Scalars["String"]["input"];
}>;

export type UpdateOrganizationSamlCertificateMutation = {
  __typename?: "Mutation";
  updateOrganizationSamlCertificate: {
    __typename?: "Organization";
    id: string;
    samlIntegration?: {
      __typename?: "SamlIntegration";
      id: string;
      idpCertExpiresAt?: number | null;
    } | null;
  };
};

export const UpdateOrganizationSamlCertificateDocument = gql`
  mutation UpdateOrganizationSamlCertificate(
    $organizationSlug: ID!
    $idpCert: String!
  ) {
    updateOrganizationSamlCertificate(
      organizationSlug: $organizationSlug
      idpCert: $idpCert
    ) {
      id
      samlIntegration {
        id
        idpCertExpiresAt
      }
    }
  }
`;
export type UpdateOrganizationSamlCertificateMutationFn =
  Apollo.MutationFunction<
    UpdateOrganizationSamlCertificateMutation,
    UpdateOrganizationSamlCertificateMutationVariables
  >;

/**
 * __useUpdateOrganizationSamlCertificateMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationSamlCertificateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationSamlCertificateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationSamlCertificateMutation, { data, loading, error }] = useUpdateOrganizationSamlCertificateMutation({
 *   variables: {
 *      organizationSlug: // value for 'organizationSlug'
 *      idpCert: // value for 'idpCert'
 *   },
 * });
 */
export function useUpdateOrganizationSamlCertificateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateOrganizationSamlCertificateMutation,
    UpdateOrganizationSamlCertificateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateOrganizationSamlCertificateMutation,
    UpdateOrganizationSamlCertificateMutationVariables
  >(UpdateOrganizationSamlCertificateDocument, options);
}
export type UpdateOrganizationSamlCertificateMutationHookResult = ReturnType<
  typeof useUpdateOrganizationSamlCertificateMutation
>;
export type UpdateOrganizationSamlCertificateMutationResult =
  Apollo.MutationResult<UpdateOrganizationSamlCertificateMutation>;
export type UpdateOrganizationSamlCertificateMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateOrganizationSamlCertificateMutation,
    UpdateOrganizationSamlCertificateMutationVariables
  >;
